import React from 'react';
import clsx from 'clsx';

const Td = ({ children, extraClasses, onClick, isLeft }) => {
  return (
    <div onClick={onClick} className={clsx('td', isLeft && 'td--left', extraClasses)}>
      {children}
    </div>
  );
};

export default Td;
